import React from 'react';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import styles from "../../styles/ProjectList.module.css";
import { useTheme } from "@mui/material";

const ExcelExport = ({ data, fileName }) => {
  const theme = useTheme();
  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], {type: 'application/octet-stream'});
    saveAs(blob, `${fileName}.xlsx`);
  };

  return (
    <button onClick={exportToExcel} className={styles.btnexcel}
    style={{
      color: theme?.customSettings?.themeColor,
      border: `1px solid ${theme?.customSettings?.themeColor}`,
    }}
    >
      Export in Excel</button>
  );
}

export default ExcelExport;